import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import '@cfa/react-components/dist/styles.min.css';

import 'styles/reset.css';
import 'styles/antdGlobals__MODIFIED.css';
import 'styles/bootstrapCustom';
import 'styles/global.scss';
import * as FontAwesome from 'styles/fontAwesomeIcons';
import { App } from './App';
import { preventI18nTreeShake } from 'i18n';
// The antd styles get applied in the component, so these overrides have to go after "App"
import 'styles/antdOverrides.scss'; 

preventI18nTreeShake();
FontAwesome.init();

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('app')
);
